import React, { useEffect } from 'react';
import { ArrowUpRight } from 'lucide-react';
import SEO from '../components/SEO';
import Container from '../components/ui/Container';
import BlogSection from '../components/BlogSection';
import './Blog.css';

const Blog = () => {
  // 페이지 마운트 시 스크롤을 상단으로 이동
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: '블로그 - Flowto.AI',
    description: 'Flowto.AI가 서비스를 만들며 배운 것들',
    url: 'https://flowto-ai.com/blog',
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '홈',
          item: 'https://flowto-ai.com'
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: '블로그',
          item: 'https://flowto-ai.com/blog'
        }
      ]
    }
  };

  return (
    <div className="blog-page">
      <SEO
        title="블로그"
        description="Flowto.AI가 서비스를 만들며 배운 것들을 기록합니다."
        url="/blog"
        structuredData={structuredData}
      />

      <header className="blog-hero">
        <Container>
          <div className="blog-hero__layout">
            <div className="blog-hero__copy">
              <span className="blog-hero__eyebrow">Blog</span>
              <h1 className="blog-hero__title">만들면서 배운 것들.</h1>
              <p className="blog-hero__sub">
                서비스를 만들고 운영하며 겪은 일과 알게 된 것을 기록합니다.
              </p>
            </div>
            <a
              className="blog-hero__link"
              href="https://blog.flowto-ai.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              blog.flowto-ai.com
              <ArrowUpRight size={16} strokeWidth={2.5} />
            </a>
          </div>
        </Container>
      </header>

      <BlogSection />
    </div>
  );
};

export default Blog;
